import { v4 as uuid } from 'uuid';
import { getLocaleStore } from '@/i18n/index';
import {
    DEFAULT_FONT_FAMILY,
    LayerType,
    TextAlignType,
    TextWritingType,
    type ILayerProps,
    type ISize,
    type ITextLayerProps,
} from '@/version-types';
import { DEFAULT_LINE_HEIGHT_FACTOR } from '../constants';

export const getDefaultLayerWithEffectsForShortcut = (stageSize: ISize) => {
    const { locale } = getLocaleStore();
    const isCN = locale === 'cn';

    const { width: stageWidth, height: stageHeight } = stageSize;
    // 提取最小字号 6，以及倍数 0.073
    const fontSize = Math.max(6, Number((stageWidth * 0.073).toFixed(0)));
    const defaultLayerDataFontSize = 218;
    const ratio = fontSize / defaultLayerDataFontSize;
    const defaultLayerData: ITextLayerProps = {
        text: isCN ? '双击编辑文字' : 'Tap twice to edit',
        color: '#ff5b5bff',
        fontSize: defaultLayerDataFontSize,
        fontFamily: DEFAULT_FONT_FAMILY().name,
        lineSpacing: DEFAULT_LINE_HEIGHT_FACTOR,
        letterSpacing: 0,
        bold: false,
        italic: false,
        lineThrough: false,
        underline: false,
        textAlign: TextAlignType.CENTER,
        writingMode: TextWritingType.HORIZONTAL_TB,
        textBackground: [],
        textShadow: [
            {
                color: '#802626ff',
                hidden: false,
                x: Math.ceil(14 * ratio),
                y: Math.ceil(4 * ratio),
                blur: 2,
            },
        ],
        textGradient: {
            colors: [
                {
                    color: '#fff7bfff',
                    value: 0.4104420731707317,
                },
                {
                    color: '#ff5f46ff',
                    value: 1,
                },
            ],
            angle: 180,
        },
        textGlow: [],
        textStroke: [
            {
                color: '#7e1919ff',
                hidden: false,
                direction: 0,
                width: Math.ceil(6 * ratio),
            },
        ],
        listStyle: '',
    };

    defaultLayerData.fontSize = fontSize;

    const defaultLayerWidth = isCN ? 1352 : 1851;
    const defaultLayerHeight = 262;

    const width = Number((defaultLayerWidth * ratio).toFixed(0));
    const height = Number((defaultLayerHeight * ratio).toFixed(0));

    defaultLayerData.lineSpacing = height / fontSize;

    const top = (stageHeight - height) / 2;
    const left = (stageWidth - width) / 2;

    const layer: ILayerProps = {
        id: uuid(),
        layerType: LayerType.TEXT_LAYER,
        width,
        height,
        top,
        left,
        fitWidth: 0,
        fitHeight: 0,
        rotate: 0,
        opacity: 1,
        lock: false,
        shine: true,
        hidden: false,
        title: '',
        flipH: false,
        flipV: false,
        data: defaultLayerData,
        materialIds: {},
        children: [],
        __runtime: {
            isInit: true,
        },
    };

    return layer;
};
